import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.POETS_PATH;

export const LEVEL_COUNT = 14;
export const TAGGING_TIMEOUT_COUNT = 5;
export const ITEMS_PER_ROUND = 3;
export const MAX_LINES = 6; // the most lines a poem can have before it overflows the bounds
export const MAX_SKILLS = 4; // the max skills for a single poem
export const MAX_BLANKS = 6; // the max number of blanks in a single cloze stanza
export const HIGHLIGHT_COLORS = {
  BASE_COLORS: ['#FFDDA3', '#c0e6ff', '#eed2ff', '#c8f08f'],
  BORDER_COLORS: ['#D74108', '#3b74be', '#9651d4', '#4b8400'],
};

export const BOSS_FACE_NEUTRAL = 0;
export const BOSS_FACE_SURPRISE = 1;
export const BOSS_FACE_HAPPY = 2;

export const BOUNCE_DURATION = 400;

// frame reference for character animations
export const PIXIE_FRAMES = {
  IDLE: [0, 45],
  FLY_FAST: [46, 61],
  TAG: [62, 85],
};

export const BOSSES = {
  ONOMATOPOEIA: 'Onomatopoeia',
  END_RHYME: 'End Rhyme',
  INTERNAL_RHYME: 'Internal Rhyme',
  ALLITERATION: 'Alliteration',
  REPETITION: 'Repetition',
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD',
  CLOZE_VIEW: 'CLOZE',
  LOADING: 'LOADING',
  ONBOARDING: 'ONBOARDING',
  INTRODUCTION_ONBOARDING: 'INTRODUCTION_ONBOARDING',
  MECHANICAL_ONBOARDING: 'MECHANICAL_ONBOARDING',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
  ONBOARDING_OUTRO: 'ONBOARDING_OUTRO',
  BOSS_INTRO: 'BOSS_INTRO',
  END_CLOZE_WIN: 'END_CLOZE_WIN',
  END_CLOZE_FAIL: 'END_CLOZE_FAIL',
  STANDARD_INTRO: 'STANDARD_INTRO',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_ROUND: 'INITIALIZE_ROUND',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  SELECT_RESPONSE: 'SELECT_RESPONSE',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
  SET_LEVEL_MAP: 'SET_LEVEL_MAP',
  SET_CLOZE_MAP: 'SET_CLOZE_MAP',
  SET_CLOZE_STATUS: 'SET_CLOZE_STATUS',
  SET_GALLERY_BOSS: 'SET_GALLERY_BOSS',
  SET_BOSS: 'SET_BOSS',
  SET_CATEGORY: 'SET_CATEGORY',
  SET_POSSIBLE_OPTIONS: 'SET_POSSIBLE_OPTIONS',
  INCREMENT_QUESTION_INDEX: 'INCREMENT_QUESTION_INDEX',
  ADD_MAX_CORRECT_ITEMS: 'ADD_MAX_CORRECT_ITEMS',
  ADD_INCORRECT_ITEMS: 'ADD_INCORRECT_ITEMS',
  ADD_CORRECT_ITEMS: 'ADD_CORRECT_ITEMS',
  QUICK_ROUND: 'QUICK_ROUND',
};
